import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const NavigationArrowBackIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
